module.exports = __webpack_public_path__ + "static/media/empty.20ee89c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/painel/pages/promocoes/empty.png
// module id = 611
// module chunks = 0